import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#time-select" }),
    /*#__PURE__*/_createTextVNode(" TimeSelect ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Use Time Select for time input. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIFixedTimePicker = _resolveComponent("EUIFixedTimePicker")
  const _component_EUIFixedTimeRange = _resolveComponent("EUIFixedTimeRange")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIFixedTimePicker),
    _createVNode(_component_EUIFixedTimeRange)
  ], 64))
}